import { nanoid } from 'nanoid';

/** 仅在当前 JS 页面实例中缓存，避免新页签复制浏览器存储。 */
let runtimeTabId = '';

/**
 * 获取当前页面实例的画布锁 tab_id，避免复制页签时沿用 sessionStorage 中的 ID。
 */
export function getTeamCanvasLockTabId(): string {
  if (typeof window === 'undefined') {
    return nanoid();
  }
  if (!runtimeTabId) {
    runtimeTabId = nanoid();
  }
  return runtimeTabId;
}
